module.exports = __webpack_public_path__ + "static/media/cert.fffcb166.png";